import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_JUGADORES = 'ALL_JUGADORES';
export const ACTIVO_JUGADORES = 'ACTIVO_JUGADORES';
export const LOADING_ALL_JUGADORES = 'LOADING_ALL_JUGADORES';
export const PARAMS_JUGADORES = 'PARAMS_JUGADORES';

const initialState = {
  all: [],
  activo: null,
  loadingAll: false,
  params: {
    torneo: null,
  },
};

export const jugadoresReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_JUGADORES:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_JUGADORES:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_JUGADORES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_JUGADORES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
